module.exports = __webpack_public_path__ + "assets/img/contentBj5.69c1824d.png";